// Vendor Libs
import {get, cloneDeep, set} from 'lodash';

const searchFormInitialState = {
    visibleFields: [],
};

const searchFormsInitialStates = {
    shelfItems: set(cloneDeep(searchFormInitialState), 'visibleFields', ['name']),
    mediaItemsEnhanced: set(cloneDeep(searchFormInitialState), 'visibleFields', [
        'title||showName',
        'exactSearch',
        'externalNetwork.name',
        'service.serviceName',
        'state',
        'amsFranchise.echostarId||amsEpisode.echostarId',
        'idFromPartner',
        'guid||externalGuid',
    ]),
    unmappedMediaItems: set(cloneDeep(searchFormInitialState), 'visibleFields', [
        'title||showName',
        'exactSearch',
        'externalNetwork.name',
        'service.serviceName',
        'state',
        'idFromPartner',
        'guid||externalGuid',
    ]),
    mediaItemsMapped: set(cloneDeep(searchFormInitialState), 'visibleFields', [
        'title||showName',
        'exactSearch',
        'externalNetwork.name',
        'service.serviceName',
        'state',
        'idFromPartner',
        'guid||externalGuid',
    ]),
};

export const getSearchFormsInitialState = formName =>
    cloneDeep(get(searchFormsInitialStates, formName, searchFormInitialState));

export default searchFormsInitialStates;
